/*
 * @Author: 2221206747@qq.com 2221206747@qq.com
 * @Date: 2025-10-27 09:41:55
 * @LastEditors: 2221206747@qq.com 2221206747@qq.com
 * @LastEditTime: 2025-12-01 17:11:26
 * @FilePath: \dome-live-ai-fontend-user\src\store\modules\liveRoom\actions\websocketExperienceAsk.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { getToken } from "@/utils/auth";
import type { RootState } from "../state";
import { HTTP_HEADERS } from "@/config/httpHead";

export async function initExperienceAskWebSocket(
  this: RootState & { [key: string]: any },
  roomId: string
): Promise<WebSocket> {
  if (!roomId) return Promise.reject("No room context for ExperienceAsk WS");
  const state = this.roomStates.get(roomId);
  state.experienceAskMessageList = [];

  const params = {
    roomId: roomId
  };

  const token = getToken();
  const wsProtocol = window.location.protocol === "https:" ? "wss:" : "ws:";
  const wsHost = window.location.host;
  let wsUrl = "";
  if (import.meta.env.VITE_API_BASE_WS) {
    wsUrl = `${import.meta.env.VITE_API_BASE_WS}/live/liveExperienceAsk?token=${token}&roomId=${encodeURIComponent(params.roomId)}`;
  } else {
    wsUrl = `${wsProtocol}//${wsHost}${HTTP_HEADERS.Ws}/live/liveExperienceAsk?token=${token}&roomId=${encodeURIComponent(params.roomId)}`;
  }
  return new Promise((resolve, reject) => {
    const ws = new WebSocket(wsUrl);

    ws.onopen = () => {
      resolve(ws);
    };

    ws.onmessage = event => {
      try {
        const data = JSON.parse(event.data);
        console.log(`✅ WebSocket消息接收:`, data);
        if (data && data.type === "ping") {
          const pingMessage = {
            type: "pong",
            timestamp: Date.now()
          };
          ws.send(JSON.stringify(pingMessage));
        }
        if (data && data.content) {
          state.experienceAskMessageList.push(data);
        }
      } catch (error) {
        console.error(`❌ WebSocket消息解析失败:`, error, event.data);
      }
    };

    ws.onerror = error => {
      console.warn(
        `Experience WebSocket for room ${roomId} connection error:`,
        error
      );
      reject(error);
    };

    // ws.onclose = event => {};
  });
}
